import { useState } from "react";
import errorHandler from "../../../errors/errorHandler";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PostApis = {
  "mayo": "/api/cases/create-mayo",
  "gi": "/api/cases/create-gi",
}

const DEFAULT_POST_API = "/api/cases/create-gi";
// Custom-tenant facilities fall back to the GI case creation endpoint so that
// configurable gister forms can still be tested end-to-end.

const HeaderText = {
  "mayo": "TAVR & Angiogram Patient Guidance System",
  "gi": "Endoscopy Patient’s Guidance System",
}

export function useGister({ hospitalName }) {  
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const submit = (data) => {
    if(isLoading) return;
    setIsLoading(true);
    // handle errors | Validation
    const endpoint = PostApis[hospitalName] || DEFAULT_POST_API;
    axios
      .post(endpoint, data)
      .then(() => navigate("/"))
      .finally(() => setIsLoading(false));
  }

  const getHeaderText = () => {
    return HeaderText[hospitalName];
  }

  return {
    submit,
    getHeaderText
  }
}